import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Leads from "@/pages/Leads";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/leads" element={<Leads />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
